// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-admin-admin-module__adminTab--DRxiD {
  .src-js-admin-admin-module__tab-content--vDGNW {
    .src-js-admin-admin-module__tab-pane--PmENf {
      margin-top: 0;
    }
  }
}

.src-js-admin-admin-module__newUserBtn--BgqUA {
  display: flex;
  justify-content: end;
  margin-bottom: 5px;
}

.src-js-admin-admin-module__displayFlex--OeEc9 {
  display: flex;
}

.src-js-admin-admin-module__titleText--ZvUc4 {
  display: inline-block;
  margin-right: 10px;
  font-size: 14px;
}

.src-js-admin-admin-module__textTransformUpper--ghzNK {
  text-transform: uppercase;
}

.src-js-admin-admin-module__headerMarginLeft--hA9v7 {
  margin-left: 0.3rem;
}

.src-js-admin-admin-module__headerMarginBottom--LbeDp {
  margin-bottom: 10px;
}

.src-js-admin-admin-module__modalBorder--qxkum {
  background: #071c35;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 1px;
}

.src-js-admin-admin-module__blink--kl6db {
  font-weight: bold;
  animation: src-js-admin-admin-module__blinkFade--EgXWl 2s ease-in-out infinite;
  padding-bottom: 10px;
  color: #071c35;
}

@keyframes src-js-admin-admin-module__blinkFade--EgXWl {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}

.src-js-admin-admin-module__userCount--U4aeV {
  padding: 10px;
  color: gray;
  font-weight: bold;
  font-size: 12px;
}

.src-js-admin-admin-module__searchText--AVt7e {
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/js/admin/admin.module.css"],"names":[],"mappings":"AAAA;EACE;IACE;MACE,aAAa;IACf;EACF;AACF;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,8EAA4C;EAC5C,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".adminTab {\n  .tab-content {\n    .tab-pane {\n      margin-top: 0;\n    }\n  }\n}\n\n.newUserBtn {\n  display: flex;\n  justify-content: end;\n  margin-bottom: 5px;\n}\n\n.displayFlex {\n  display: flex;\n}\n\n.titleText {\n  display: inline-block;\n  margin-right: 10px;\n  font-size: 14px;\n}\n\n.textTransformUpper {\n  text-transform: uppercase;\n}\n\n.headerMarginLeft {\n  margin-left: 0.3rem;\n}\n\n.headerMarginBottom {\n  margin-bottom: 10px;\n}\n\n.modalBorder {\n  background: #071c35;\n  padding-left: 15px;\n  padding-right: 15px;\n  padding-bottom: 1px;\n}\n\n.blink {\n  font-weight: bold;\n  animation: blinkFade 2s ease-in-out infinite;\n  padding-bottom: 10px;\n  color: #071c35;\n}\n\n@keyframes blinkFade {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n  }\n}\n\n.userCount {\n  padding: 10px;\n  color: gray;\n  font-weight: bold;\n  font-size: 12px;\n}\n\n.searchText {\n  margin-right: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"adminTab": `src-js-admin-admin-module__adminTab--DRxiD`,
	"tab-content": `src-js-admin-admin-module__tab-content--vDGNW`,
	"tab-pane": `src-js-admin-admin-module__tab-pane--PmENf`,
	"newUserBtn": `src-js-admin-admin-module__newUserBtn--BgqUA`,
	"displayFlex": `src-js-admin-admin-module__displayFlex--OeEc9`,
	"titleText": `src-js-admin-admin-module__titleText--ZvUc4`,
	"textTransformUpper": `src-js-admin-admin-module__textTransformUpper--ghzNK`,
	"headerMarginLeft": `src-js-admin-admin-module__headerMarginLeft--hA9v7`,
	"headerMarginBottom": `src-js-admin-admin-module__headerMarginBottom--LbeDp`,
	"modalBorder": `src-js-admin-admin-module__modalBorder--qxkum`,
	"blink": `src-js-admin-admin-module__blink--kl6db`,
	"blinkFade": `src-js-admin-admin-module__blinkFade--EgXWl`,
	"userCount": `src-js-admin-admin-module__userCount--U4aeV`,
	"searchText": `src-js-admin-admin-module__searchText--AVt7e`
};
export default ___CSS_LOADER_EXPORT___;
